<template>
  <div class="d-flex align-center">
    <v-icon
      v-for="index in max"
      :key="index"
      :color="getColor(index)"
      :size="size"
    >
      {{ getIcon(index) }}
    </v-icon>
  </div>
</template>

<script>
export default {
  name: "HalfStarRating",
  props: {
    value: {
      type: Number,
      required: true,
    },
    max: {
      type: Number,
      default: 5,
    },
    color: {
      type: String,
      default: "primary",
    },
    size: {
      type: [Number, String],
      default: 28,
    },
  },
  methods: {
    getIcon(index) {
      if (this.value >= index) return "mdi-star";
      if (this.value >= index - 0.5) return "mdi-star-half";
      return "mdi-star-outline";
    },
    getColor(index) {
      return this.value >= index - 0.5 ? this.color : "grey";
    },
  },
};
</script>
